import { createSelector } from 'redux-orm';
import Store from '..';

export namespace ModalSelectors {
	export const getModals = createSelector(Store.ORM, (session) =>
		session.Modal.all().toRefArray()
	);
}
